import React from 'react'

const House = () => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.7 10.1691L19 5.49252H19.3C19.7 5.49252 20 5.19402 20 4.79601C20 4.2985 19.6 4 19.2 4H8.7C8.3 4 8 4.2985 8 4.69651C8 5.09452 8.3 5.39302 8.7 5.39302H9L4.3 10.1691C4.1 10.3681 4 10.5671 4 10.8656V11.4626C4 12.5571 4.9 13.4526 6 13.4526C7.1 13.4526 8 12.5571 8 11.4626C8 12.5571 8.9 13.4526 10 13.4526C11.1 13.4526 12 12.5571 12 11.4626C12 12.5571 12.9 13.4526 14 13.4526C15.1 13.4526 16 12.5571 16 11.5621C16 12.6566 16.9 13.4526 18 13.4526C19.1 13.4526 20 12.5571 20 11.4626C20 12.5571 20.9 13.4526 22 13.4526C23.1 13.4526 24 12.5571 24 11.4626V10.8656C24 10.5671 23.9 10.3681 23.7 10.1691Z"
        fill="#1072EB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 14.4479V22.408C6 24 7.2 24 8.8 24C8.9 24 9 24 9 24H10.4C10.7 24 11 23.7015 11 23.403V19.6219C11 17.9304 12.3 16.6369 14 16.6369C15.7 16.6369 17 17.9304 17 19.6219V23.403C17 23.7015 17.3 24 17.6 24H19C19.1 24 19.2 24 19.2 24C20.7 24 22 24 22 22.408V14.4479C21.2 14.4479 20.5 14.1493 20 13.6518C19.5 14.1493 18.8 14.4479 18 14.4479C17.2 14.4479 16.5 14.1493 16 13.6518C15.5 14.1493 14.8 14.4479 14 14.4479C13.2 14.4479 12.5 14.1493 12 13.6518C11.5 14.1493 10.8 14.4479 10 14.4479C9.2 14.4479 8.5 14.1493 8 13.6518C7.5 14.1493 6.8 14.4479 6 14.4479Z"
        fill="#1072EB"
      />
    </svg>
  )
}

export default House
